// Maps a student's declared school year (e.g. "Sec 3") to an SGLearner subject level.
export function levelFromCurrentLevel(cl) {
  if (!cl) return '';
  const s = cl.toLowerCase();
  if (/^p[1-6]$|primary/.test(s))      return 'PSLE';
  if (/sec|secondary|o.level/.test(s)) return 'O-Level';
  if (/jc|a.level/.test(s))            return 'JC';
  if (/poly|ite|post.sec/.test(s))     return 'O-Level';
  if (/\bib\b/.test(s))               return 'IB';
  if (/\bip\b/.test(s))               return 'IP';
  return '';
}
